export default __webpack_public_path__ + "static/media/sxminfraCoin.a919798b.svg";